import { LogbookView } from '../logbook/LogbookView';
import { useAircraft } from './AircraftDetailLayout';

export function AircraftLogbookTab() {
  const aircraft = useAircraft();
  return <LogbookView kind="AIRCRAFT" subjectId={aircraft.id} aircraftId={aircraft.id} />;
}
